/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id, userId: ZodTypes.Id });

export const PatchOrganizationUser = {
  id: 'organization-user.patch',
  tag: 'Organization',
  summary: 'Change organization user role',
  description:
    'Only owners may change the roles of other users.\n' +
    'It is possible for owners to change the role of another owner, or even of themself.\n' +
    '\n' +
    "There must always be at least one owner left after the transaction, else the role can't be changed.",
  method: 'patch',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/user/${params.userId}`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            role: ZodTypes.RBAC.Organization.Roles,
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
